import { CountryDropdown } from "react-country-region-selector";
import { useSelector } from "react-redux";

interface Props {
    id: string;
    name: string;
    labelText?: string;
    country: string;
    selectCountry: (val: string) => void;
    required?: boolean;
    isInvalid?: boolean | string;
    valueType?: "full" | "short";
    errorMessage?: string;
    blacklist?: string[];
    disabled?: boolean;
}

const CountrySelector = ({
    id,
    name,
    labelText,
    country,
    selectCountry,
    required,
    isInvalid,
    valueType = "short",
    errorMessage,
    blacklist,
    disabled,
}: Props) => {
    const currentUser = useSelector((state: any) => state.users.currentUser);

    const { userType } = currentUser;

    return (
        <div className="from-group mb-4">
            {labelText && (
                <label htmlFor={id}>
                    {labelText}
                    {required ? <span className="text-danger">*</span> : ""}
                </label>
            )}

            <CountryDropdown
                id={id}
                name={name}
                classes={`form-control mb-0 ${isInvalid ? "is-invalid" : ""}`}
                value={country}
                valueType={valueType}
                onChange={(val) => {
                    selectCountry(val);
                }}
                whitelist={Number(userType) === 1 ? currentUser.country : undefined}
                blacklist={blacklist ?? undefined}
                disabled={disabled}
            />
            {isInvalid && (
                <div className="invalid-feedback">
                    {isInvalid && (errorMessage ?? "Invalid Value")}
                </div>
            )}
        </div>
    );
};

export default CountrySelector;
